<template>
  <div class="swiper-video">
    <video
      :src="baseUrl + picture.field_media_video_file"
      loop
      muted
      autoplay
    ></video>
  </div>
</template>

<script>
export default {
  props: {
    picture: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    baseUrl: "",
  }),
  mounted() {
    this.baseUrl = process.env.VUE_APP_API_BASE_URL;
  },
};
</script>

<style lang="scss">
.swiper-video {
  height: 100%;
  aspect-ratio: 1/1.34;
  background: linear-gradient(
    90deg,
    rgba(#6d00cf, 1) 0%,
    rgba(#6d00cf, 0.6) 50%,
    rgba(#6d00cf, 1) 100%
  );
  background-size: 200% 100%;

  video {
    width: 100%;
    height: 100%;
  }
  // animation: moveBackground 2s infinite linear;
}

@keyframes moveBackground {
  0% {
    background-position: 200% 0%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
